import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import GoogleAuthButton from "@/components/GoogleAuthButton";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const r = await login(email, password);
    setLoading(false);
    if (r.ok) { toast.success("Welcome back"); nav("/"); }
    else toast.error(r.error);
  };

  return (
    <div className="max-w-md mx-auto px-5 py-16">
      <div className="rounded-2xl bg-white border border-[#E2DED0] p-8">
        <div className="text-xs uppercase tracking-[0.2em] text-[#C05A3D] font-semibold">Welcome back</div>
        <h1 className="font-display text-3xl text-[#1E3A2F] mt-1">Sign in</h1>
        <div className="mt-6">
          <GoogleAuthButton />
        </div>
        <div className="my-5 flex items-center gap-3 text-xs uppercase tracking-[0.15em] text-[#5C5C5C]">
          <span className="flex-1 h-px bg-[#E2DED0]" /> or with email <span className="flex-1 h-px bg-[#E2DED0]" />
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label>Email</Label>
            <Input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div>
            <Label>Password</Label>
            <Input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          <Button data-testid="login-submit" type="submit" disabled={loading} className="abm-btn-primary rounded-full w-full h-11">
            {loading ? "Signing in…" : "Sign in"}
          </Button>
        </form>
        <div className="mt-5 text-sm text-[#5C5C5C]">
          New here? <Link to="/signup" className="text-[#C05A3D] font-medium">Create an account</Link>
        </div>
      </div>
    </div>
  );
}
